<template>
  <div class="video-player-container">
    <div class="cfstream-container">
      <div class="cfstream-player" v-html="selectedVideo.CFStream[0]"></div>
      <div class="cfstream-name">
        {{ selectedVideo.Name[0] }}
      </div>
      <v-switch
        color="black"
        flat
        inset
        v-if="hasTranscript"
        v-model="isTranscriptShown"
        :label="switchLabel"
      ></v-switch>
    </div>
    <div class="left-container">
      <div class="transcript-container">
        <div class="transcript-content" v-if="isTranscriptShown">
          <v-toolbar flat>
            <v-spacer>Transcript</v-spacer>
            <v-btn icon @click="hideTranscript()" class="close-btn">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <div class="transcript-label" v-html="transcriptContent"></div>
        </div>
      </div>
      <div class="playlist-container">
        <template
          v-if="sectionContent.Media.length > 1"
        >
          <div class="up-next-label">Up next</div>
          <div v-for="index in 2" :key="index" class="video-card">
            <template v-if="selectedIndex === sectionContent.Media.length-1">
              <div v-if="sectionContent.Media[index]" class="video-item">
                <div
                  @click.stop="setSelectedVideo(sectionContent.Media[index-1], index-1)"
                >
                  <VideoThumbnail>
                    <template #video-thumbnail>
                      <img :src="sectionContent.Media[index-1].Thumbnail[0]" />
                    </template>
                    <template #video-title
                      >{{ sectionContent.Media[index-1].Name[0] }}
                    </template>
                  </VideoThumbnail>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                v-if="sectionContent.Media[selectedIndex + index]"
                class="video-item"
              >
                <div
                  @click.stop="setSelectedVideo(sectionContent.Media[selectedIndex +index], selectedIndex + index)"
                >
                  <VideoThumbnail>
                    <template #video-thumbnail>
                      <img
                        :src="sectionContent.Media[selectedIndex + index].Thumbnail[0]"
                      />
                    </template>
                    <template #video-title
                      >{{ sectionContent.Media[selectedIndex + index].Name[0] }}
                    </template>
                  </VideoThumbnail>
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import VideoThumbnail from '@/components/media/VideoThumbnail'
export default {
  name: 'VideoPlayer',
  components: {
    VideoThumbnail
  },
  props: [
    'chapter',
    'section',
    'clickedVideo',
    'clickedIndex',
    'sectionContent'
  ],
  data () {
    return {
      isTranscriptShown: false,
      transcriptContent: null,
      hasTranscript: false,
      selectedVideo: null,
      selectedIndex: 0
    }
  },
  beforeMount () {
    this.selectedVideo = this.clickedVideo
    this.selectedIndex = this.clickedIndex
    if (this.selectedVideo.Caption && this.selectedVideo.Caption[0] !== '') {
      this.getTranscriptContent(this.selectedVideo.Caption[0])
    } else {
      this.hasTranscript = false
    }
  },
  mounted () {
    this.setGATracker()
  },
  updated () {
    if (this.selectedVideo.Caption && this.selectedVideo.Caption[0] !== '') {
      this.getTranscriptContent(this.selectedVideo.Caption[0])
    } else {
      this.hasTranscript = false
    }
    this.setGATracker()
  },
  methods: {
    setSelectedVideo (media, index) {
      this.selectedVideo = media
      this.selectedIndex = index
      this.isTranscriptShown = false
    },
    getTranscriptContent (filePath) {
      axios.get(filePath).then(response => {
        if (response.data) {
          this.hasTranscript = true
          this.transcriptContent = response.data
        }
      }).catch(error => {
        this.hasTranscript = false
      })
    },
    hideTranscript () {
      this.isTranscriptShown = false
    },
    setGATracker () {
      let isOnLoop = false
      if (this.selectedVideo.CFStream[0].includes('loop=true')) {
        isOnLoop = true
      }
      const player = Stream(document.querySelector('.cfstream-player iframe'))
      player.addEventListener('play', () => {
        this.$gtm.trackEvent({
          event: 'user_played_video',
          category: 'Media',
          action: 'play',
          label: 'User played video',
          productName: this.bookTitle,
          chapterName: this.chapter,
          sectionTitle: this.section,
          videoTitle: this.nowPlaying,
          isMediaPlayed: 'true',
          isVideoOnLoop: isOnLoop
        })
      })

      player.addEventListener('ended', () => {
        this.$gtm.trackEvent({
          event: 'user_finished_video',
          category: 'Media',
          action: 'completed',
          label: 'User finished watching video',
          productName: this.bookTitle,
          chapterName: this.chapter,
          sectionTitle: this.section,
          videoTitle: this.nowPlaying,
          isMediaFinished: 'true'
        })
      })
    }
  },
  computed: {
    switchLabel () {
      return this.isTranscriptShown ? 'Hide transcript' : 'Show transcript'
    }
  }
}
</script>

<style lang="scss">
.video-player-container {
  margin: auto;
  display: grid;
  grid-template-columns: 60% auto 30%;
  @media screen and (max-width: 601px) {
    grid-template-columns: repeat(1, 80%);
    justify-content: center;
  }
  .cfstream-container {
    .cfstream-player {
      div {
        padding-top: 0% !important;
      }
      iframe {
        position: relative !important;
        max-width: 720px;
        max-height: 376px;
        width: 100%;
        @media only screen and (min-width: 601px) {
          min-height: 376px;
        }
        @media only screen and (max-width: 600px) {
          min-height: 166px;
        }
      }
    }
    .cfstream-name {
      font-weight: 600;
      font-size: 15px;
      padding-top: 10px;
    }
    .v-label {
      color: #323232;
      font-weight: 500;
      font-size: 15px;
    }

    .v-input--selection-controls__input {
        height: 16px;
        width: 30px;
        transform: scale(0.6);
      }
  }
  .left-container {
    @media only screen and (min-width: 601px) {
      grid-column-start: 3;
    }
    .transcript-container {
      .transcript-content {
        padding: 5px;
        border: 1px solid #e0e0e0;
        box-sizing: border-box;
        font-size: 15px;
        .v-toolbar {
          height: auto !important;
          .v-toolbar__content {
            padding: 0px;
            height: auto !important;
            .spacer {
              font-weight: 600;
            }
          }
        }
      }
      .transcript-label {
        max-height: 300px;
        overflow-y: auto;
      }
    }
    .playlist-container {
      color: #323232;
      margin: 20px 0px;
      .up-next-label {
        padding-bottom: 10px;
        font-weight: 600;
        font-size: 15px;
      }
    }
  }
}
</style>
